<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="2">
                <label for="select-rfi-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-cor"  v-model="valor_empresa"                   
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true" 
                  @close="loadFiliais()" 
                  :preserve-search="true" placeholder="Selecione a empresa" label="nomeempresarial" track-by="nomeempresarial" name="nomeempresarial"              >                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>
              

              <b-col cols="2">
                <label for="select-rfi-filial">Filial</label>  
                <multiselect id="selecao-filial-cor"  v-model="valor_filial"                    
                  :options="filiais" 
                  :multiple="true"   
                  @close="loadSituacao()"                                 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-rfi-situacao">Situação</label>
                <multiselect  v-model="valor_situacao"  
                  :options="situacoes" 
                  :multiple="true"                   
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a situacao" label="situacao" track-by="situacao" name="situacao"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} situação selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2">
                <label for="select-rfi-status">Status</label> 
                <multiselect  v-model="valor_status"  
                  :options="statuss"                   
                  :multiple="true" 
                  @close="loadRfi()"
                  :close-on-select="false" 
                  :clear-on-select="false"                 
                  :preserve-search="true"   placeholder="Selecione o status" label="status" track-by="status" name="status"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>

              <b-col cols="2"  class="mb-0">
                <label  for="input-busca">Pesquisa no grid</label>
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Digite o nº do carro"></b-form-input>              
              </b-col>      

              <b-col cols="1"  class="mt-4 ml-0">
                <b-button variant="warning" class="ml-5 mt-2" @click="loadEmpresaCad(),loadSituacaoCad(),loadStatus()" block  v-b-modal.modal-multi-1  >Novo</b-button>
              </b-col>

              
              <b-col class="mr-4 ">
                <br>                
                <b-button size="sm" variant="success" class="ml-4 mt-2" block @click="carregando = true,gerarPlanilha()">
                  Gerar planilha
                </b-button>                      
              </b-col>
              
          </b-row>


     
      <b-row>
        <b-card-group class="ml-3 mt-3" deck>   


              <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="FROTA PATRIMONIAL"
                header-bg-variant="primary  "
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                    {{ Object.values(rfilancamentos)
                        .filter((item, index, self) => 
                            self.findIndex(obj => obj.filial_id === item.filial_id) === index
                        )
                        .map(fp => fp.frota_patrimonial)
                        .reduce((anterior, atual) => anterior + atual, 0)
                    }}


                  </h2>
                </b-card-text>
              </b-card>

              <!--    RESERVA TECNICA           -->
              <!--    RESERVA TECNICA           -->
              <!--    RESERVA TECNICA           -->

            <b-card                  
              v-if="diaDaSemana !== 0 && diaDaSemana !== 6"
              class="mr-2"              
              style="width: 33rem;"
              border-variant="success"
              header="RESERVA TECNICA"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ 
  Object.values(rfilancamentos)
    .filter((item, index, self) => 
      self.findIndex(obj => obj.filial_id === item.filial_id) === index
    )
    .map(fp => fp.frota_patrimonial)
    .reduce((anterior, atual) => anterior + atual, 0) 
  - 
  Object.values(rfilancamentos)
    .filter((item, index, self) => 
      self.findIndex(obj => obj.filial_id === item.filial_id) === index
    )
    .map(fp => fp.frota_operacional)
    .reduce((anterior, atual) => anterior + atual, 0) 
}}

                </h2>
              </b-card-text>
            </b-card>

            <b-card                  
            v-else-if="diaDaSemana === 6"
              class="mr-2"              
              style="width: 33rem;"
              border-variant="success"
              header="RESERVA TECNICA"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0)) }}
                </h2>
              </b-card-text>
            </b-card>

            <b-card                  
            v-else-if="diaDaSemana === 0"
              class="mr-2"              
              style="width: 33rem;"
              border-variant="success"
              header="RESERVA TECNICA"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0)) }}
                </h2>
              </b-card-text>
            </b-card>




    <b-card
      v-if="diaDaSemana !== 0 && diaDaSemana !== 6"
      class="mr-2"
      style="width: 33rem;"
      border-variant="primary"
      header="FROTA OPERACIONAL - UTIL "
      header-bg-variant="primary"
      header-text-variant="white"
      align="center"
    >
      <b-card-text>
        <h2>
          {{ Object.values(rfilancamentos)
    .filter((item, index, self) => 
      self.findIndex(obj => obj.filial_id === item.filial_id) === index
    )
    .reduce((anterior, fp) => anterior + (fp.frota_operacional || 0), 0)
}}

        </h2>
      </b-card-text>
    </b-card>

    <b-card
      v-else-if="diaDaSemana === 6"
      class="mr-2"
      style="width: 33rem;"
      border-variant="primary" 
      header="FROTA OPERACIONAL - SÁBADO"
      header-bg-variant="primary"
      header-text-variant="white"
      align="center"
    >
            <b-card-text>
        <h2>
                    {{ Object.values(rfilancamentos)
    .filter((item, index, self) => 
      self.findIndex(obj => obj.filial_id === item.filial_id) === index
    )
    .reduce((anterior, fp) => anterior + (fp.frota_sabado || 0), 0)
}}
        </h2>
      </b-card-text>

      
    </b-card>

    <b-card
      v-else-if="diaDaSemana === 0"
      class="mr-2"
      style="width: 33rem;"
      border-variant="warning" 
      header="FROTA OPERACIONAL - DOMINGO"
      header-bg-variant="warning"
      header-text-variant="white"
      align="center"
    >
      <b-card-text>
        <h2>
                   {{ Object.values(rfilancamentos)
    .filter((item, index, self) => 
      self.findIndex(obj => obj.filial_id === item.filial_id) === index
    )
    .reduce((anterior, fp) => anterior + (fp.frota_domingo || 0), 0)
}}
        </h2>
      </b-card-text>
    </b-card>


    <!--         RESERVA TECNICA utilizada -->
    <!--         RESERVA TECNICA utilizada -->
    <!--         RESERVA TECNICA utilizada -->    

            <b-card                  
              v-if="diaDaSemana !== 0 && diaDaSemana !== 6"
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="% RESERVA TECNICA UTILIZADA"
              header-bg-variant="warning"
              header-text-variant="black"
              align="center"
            >
              <b-card-text> 
                <h2>                  
                 {{ itemsFiltered.length ? 
                    (
                      (itemsFiltered.length / 
                        (
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_patrimonial || 0), 0) 
                          - 
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_operacional || 0), 0)
                        )
                      ) * 100
                    ).toFixed(2) + '%' 
                    : 0 
                  }}

                </h2>
              </b-card-text>
            </b-card>

            <b-card                  
            v-else-if="diaDaSemana === 6"
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="% RESERVA TECNICA UTILIZADA"
              header-bg-variant="warning"
              header-text-variant="black"
              align="center"
            >
              <b-card-text> 
                <h2>                  
                 {{ itemsFiltered.length ? 
                    (
                      (itemsFiltered.length / 
                        (
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_patrimonial || 0), 0) 
                          - 
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_sabado || 0), 0)
                        )
                      ) * 100
                    ).toFixed(2) + '%' 
                    : 0 
                  }}
                </h2>
              </b-card-text>
            </b-card>


            <b-card         
              v-else-if="diaDaSemana === 0"         
              class="mr-2"              
              style="width: 33rem;"
              border-variant="primary"
              header="% RESERVA TECNICA UTILIZADA"
              header-bg-variant="warning"
              header-text-variant="black"
              align="center"
            >
              <b-card-text> 
                <h2>                  
                                 {{ itemsFiltered.length ? 
                    (
                      (itemsFiltered.length / 
                        (
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_patrimonial || 0), 0) 
                          - 
                          Object.values(rfilancamentos)
                            .filter((item, index, self) => 
                              self.findIndex(obj => obj.filial_id === item.filial_id) === index
                            )
                            .reduce((anterior, fp) => anterior + (fp.frota_domingo || 0), 0)
                        )
                      ) * 100
                    ).toFixed(2) + '%' 
                    : 0 
                  }}
                </h2>
              </b-card-text>
            </b-card>

            

     

          <b-card
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="FROTA INDISPONIVEL"
            header-bg-variant="danger"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{itemsFiltered.length}}
              </h2>
              
            </b-card-text>
          </b-card>

          <!-- % disponibilidade da frota   -->
          <!-- % disponibilidade da frota   -->
          <!-- % disponibilidade da frota   -->
          <b-card
            v-if="diaDaSemana !== 0 && diaDaSemana !== 6"
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="% DISPONIBILIDADE DA FROTA"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{ itemsFiltered.length ?
                   ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_operacional ).reduce(function(anterior,atual){return atual ;},0)) )
                    > itemsFiltered.length 
                    ? (( rfilancamentos.map( fp => fp.frota_operacional ).reduce(function(anterior,atual){return atual ;},0)/ rfilancamentos.map( fp => fp.frota_operacional ).reduce(function(anterior,atual){return atual ;},0) ) * 100).toFixed(2) + '%'
                    :  ((1 - ( ( itemsFiltered.length - ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_operacional ).reduce(function(anterior,atual){return atual ;},0)) ) )
                    / (rfilancamentos.map( fp => fp.frota_operacional ).reduce(function(anterior,atual){return atual ;},0)) )) * 100).toFixed(2) + '%'
                    : 0
                }}
              </h2>
              
            </b-card-text>
          </b-card>


          <b-card
            v-else-if="diaDaSemana === 6"         
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="% DISPONIBILIDADE DA FROTA"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{ itemsFiltered.length ?
                   ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0)) )
                    > itemsFiltered.length 
                    ? (( rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0)/ rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0) ) * 100).toFixed(2) + '%'
                    :  ((1 - ( ( itemsFiltered.length - ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0)) ) )
                    / (rfilancamentos.map( fp => fp.frota_sabado ).reduce(function(anterior,atual){return atual ;},0)) )) * 100).toFixed(2) + '%'
                    : 0
                }}
              </h2>
              
            </b-card-text>
          </b-card>


          <b-card
            v-else-if="diaDaSemana === 0"         
            class="ml-2"
            style="width: 33rem;"
            border-variant="primary"
            header="% DISPONIBILIDADE DA FROTA"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text > 
              <h2>
                {{ itemsFiltered.length ?
                   ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0)) )
                    > itemsFiltered.length 
                    ? (( rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0)/ rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0) ) * 100).toFixed(2) + '%'
                    :  ((1 - ( ( itemsFiltered.length - ( (rfilancamentos.map( fp => fp.frota_patrimonial ).reduce(function(anterior,atual){return atual ;},0)) - (rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0)) ) )
                    / (rfilancamentos.map( fp => fp.frota_domingo ).reduce(function(anterior,atual){return atual ;},0)) )) * 100).toFixed(2) + '%'
                    : 0
                }}
              </h2>
              
            </b-card-text>
          </b-card>


          <!-- MÉDIA DE DIAS PARADO    -->
          <!-- MÉDIA DE DIAS PARADO    -->
          <!-- MÉDIA DE DIAS PARADO    -->          

            <b-card            
                class="ml-2"
                style="width: 33rem;"
                border-variant="danger"
                header="MÉDIA DE DIAS PARADO"
                header-bg-variant="danger  "
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                     {{ (itemsFiltered.map( fp => fp.dias ).reduce(function(anterior,atual){return +anterior+atual ;},0) / itemsFiltered.length).toFixed(0) }}

                  </h2>
                </b-card-text>
              </b-card>

        </b-card-group> 
     </b-row>
    </b-form>


<!-- Tabela de dados -->
<b-table id="rfilanc" small hover striped sticky-header="818px" :items="itemsFiltered" :fields="fieldsrfi">
  <template #cell(actions)="{ item }">
    <!-- Contêiner flex para alinhar a barra de progresso e o botão -->
    <div class="d-flex align-items-center">
      <!-- Barra de progresso segmentada -->
      <div class="progress-container mr-5">
        <div 
          v-for="(segment, index) in calculateProgressSegments(item)" 
          :key="index" 
          class="progress-segment" 
          :style="{ width: segment.percentage + '%', backgroundColor: segment.color }"
          :title="`${segment.situacao}: ${segment.dias_permanencia} dias`">
        </div>
      </div>

      <!-- Botão de ação -->
      <b-button @click="editCarregaRfi(item), loadEmpresaCad(), loadFiliaisCad(), loadSituacaoCad(), loadStatusCad(), loadVeiculo()"
        title="Acessar RFI" size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>
        <i class="fa fa-exclamation-circle"></i>
      </b-button>
    </div>
  </template>

  <!-- Definindo campos -->

</b-table>





      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="modal-multi-1" cancel-title="Novo"  ok-title="Gravar" @ok="postNroRfi(), reset()"  hide-footer  size="xl" title="Carros em manutenção"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>
<!--
            <b-row>
                <b-col cols="6">
                <label for="input-garagem">Empresa</label> 
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="rfi.empresa_id"                    
                    required                                                   
                    :options="empresasc"
                    @change="loadFiliaisCad()"
                    class="mb-3 "
                    text-field="nomeempresarial"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>

              <b-col cols="4">
                <label for="input-garagem">Filial</label>   
                <div>                
                  <b-form-select   
                    id="garagem"    
                    
                    v-model="rfi.filial_id"                    
                    required      
                    :options="filiaisc"                    
                    @change="loadSituacaoCad()"                                             
                    class="mb-3 "
                    text-field="filial"                                            
                  >                
                  </b-form-select>
                </div>
              </b-col>



            </b-row>
-->
            <b-row>
              <input  id="id-carro" type="hidden" v-model="rfi.carro_id" />

              
              <b-col cols="2">
                <label for="input-live">Carro</label> 
                <b-form-input id="carro" v-model="rfi.carro" required @click="reset()" @keyup.enter="loadVeiculo(),postNroRfi(),loadSituacaoCad()" placeholder="Nº do carro"></b-form-input>                                              
              </b-col>

              <b-col cols="3">
                <label class="ml-3" for="input-live">Modelo Chassi</label> 
                <b-input-group-text >{{ veiculos ? veiculos.map(at => at.chassi).join(', ') : '-' }}</b-input-group-text>
              </b-col>

              <b-col cols="2">
                <label for="input-live">Placa</label>     
                <b-input-group-text >{{ veiculos ? veiculos.map(at => at.placa).join(', ')  : '-' }}</b-input-group-text>
              </b-col> 

              <b-col cols="1">
                <label for="input-live">Nº RFI</label> 
                <b-input-group-text >{{ rfi.id > 0 ? rfi.id : nroRfi }}</b-input-group-text>
            </b-col> 

              
              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Data Parada</label>   
                  <b-form-datepicker id="dt_rfi_inicial"  required  v-model="rfi.dt_parada"  placeholder="Data parada " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>

              <b-col cols="2">
                <div>                            
                  <label  for="datepicker-placeholder">Previsão de liberação</label>
                  <b-form-datepicker id="dt_rfi_final"  required  v-model="rfi.dt_prevista_liberacao" placeholder="P liberação " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>


            </b-row>

            <b-row>
              <b-col cols="12">
                <label for="input-live">Motivo</label>
                <b-form-input v-model="rfi.motivo" required placeholder="Digite o motivo"></b-form-input>              
              </b-col>
            </b-row>  

            <b-row>

            <b-col cols="7">
              <label for="input-setor">Situação</label> 
              <div>                
                <b-form-select                  
                  v-model="rfi.situacao_id"  
                  @change="loadStatusCad()"                                            
                  required                                                   
                  :options="situacoesc"
                  class="mb-3 "
                  text-field="situacao"                            
                >
                
                </b-form-select>
              </div>
            </b-col>  

            <b-col cols="3">
              <label for="input-setor">Status</label>
              <div>                
                <b-form-select                  
                  v-model="rfi.status_id"  
                  required                           
                  :options="statussc"
                  class="mb-3 "
                  text-field="status"                            
                >
                
                </b-form-select>
              </div>
            </b-col>  

              
                <b-col cols="2">                                              
                  <b-form-checkbox
                    id="lavador" 
                    class="mb-3 mt-5"
                    v-model="rfi.lavador"                  
                    name="checkbox-1"
                    value="true"
                    unchecked-value="false"
                    checked="true"                    
                  >                  
                  Lavador <!-- --{{rfilancamento.lavador}} -->
                  </b-form-checkbox>                
                </b-col>
              
            </b-row> 

            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Peças</label> 
              </b-col>
              <b-col sm="12">
                <b-form-textarea
                  id="id-pecas" 
                  v-model="rfi.pecas"                  
                  size="sm"
                  placeholder="Digite códigos dos materias"
                ></b-form-textarea>
              </b-col>
            </b-row> 

            <b-row>
              <b-col sm="2">
                <label for="textarea-small">Descrição:</label> 
                
              </b-col>
              <b-col sm="12">
                <b-form-textarea                   
                  id="id-obs"
                  v-model="rfi.observacoes"
                  size="sm"      
                  placeholder="Digite as observações"
                ></b-form-textarea>
              </b-col>
            </b-row> 

              <b-button class="mt-3" variant="success" block @click="postRfi()">Gravar</b-button> 
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

  
  



</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex' 


export default {    
    name: 'ManutencaoRfiLancamento',  

    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.rfilancamentos.filter((item) =>{
          return (
            item.carro.indexOf(this.search) >-1 
          );
        });
        return valores
        },       

    diaDaSemana() {
      const dataAtual = new Date();
      return dataAtual.getDay(); // Retorna um número de 0 (domingo) a 6 (sábado)
    }

    } ,

    



    data: function() {

        
      
        return {            
            empresas:[],
            empresa:{},
            filiais:[],
            situacoes:[],
            statuss:[],
            valor_empresa :[],
            valor_filial:[],
            valor_situacao:[],
            valor_status:[],            

            rfilancamentos:[],            
            rfi:{},
            nroRfi:null,
            veiculos:[],
           
            
            empresasc:[],
            filiaisc:[],
            statussc:[],
            situacoesc:[],
            search:'',
            
            fieldsrfi: [
                { key: 'id', label: 'Nº', sortable: true },     
                { key: 'empresa_id', label: 'Empresa', sortable: true },                 
                { key: 'filial_id', label: 'Filial', sortable: true },                 
                { key: 'carro', label: 'Carro', sortable: true },               
                { key: 'lote', label: 'Lote', sortable: true },               
                
                
                { key: 'dt_cadastro', label: 'Dt digitação', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                
                { key: 'motivo', label: 'Motivo', sortable: true },
                { key: 'status', label: 'Status', sortable: true },                
                { key: 'situacao', label: 'Situação', sortable: true },    
                { key: 'dt_alteracao', label: 'Ultima atualização', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_alteracao).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },

                { key: 'dt_parada', label: 'Data indisponivel', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_parada).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },

                { key: 'dt_prevista_liberacao', label: 'Data prevista liberação', sortable: true, formatter: (value, key, rfilancamentos) => {
                    return moment(rfilancamentos.dt_prevista_liberacao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },

                
                { key: 'dias', label: ' Dias Parado', sortable: true },
                { key: 'pecas', label: ' Material', sortable: true },

                { key: 'observacoes', label: 'Observações', sortable: true },                
                { key: 'lavador', label: 'Lavador', sortable: true,
                    formatter: value => value ? 'Sim' : 'Não' },
        { 
        key: 'progress', 
        label: 'Permanência', 
        sortable: false, 
        columnClass: 'text-right',
        headerClass: 'text-right',  // Alinha o título à direita
        style: 'width: 220px;'  // Definindo largura fixa para a coluna "Permanência"
      },   
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

          // Método para calcular o valor da barra de progresso
    calculateProgressSegments(item) {
      if (!item.historico_permanencia || item.historico_permanencia.length === 0) {
        return [];
      }

      // Definir cores fixas para cada situação
      const situacaoColors = {
        "AR CONDICIONADO": "#ff5733",
        "GARANTIA / ALINHAMENTO": "#33ff57",
        "PEDIDO DA MANUTENÇÃO": "#337bff",
        "TROCA DE ÓLEO": "#ff33d1",
        "OUTROS": "#aaaaaa"
      };

      // Agrupar dias_permanencia por situação (somar duplicados)
      const grouped = item.historico_permanencia.reduce((acc, h) => {
        if (!acc[h.situacao]) {
          acc[h.situacao] = 0;
        }
        acc[h.situacao] += h.dias_permanencia;
        return acc;
      }, {});

      // Calcular o total de dias
      const totalDias = Object.values(grouped).reduce((sum, dias) => sum + dias, 0);

      // Criar segmentos com porcentagens corretas
      return Object.entries(grouped).map(([situacao, dias]) => ({
        situacao,
        dias_permanencia: dias,
        percentage: totalDias > 0 ? (dias / totalDias) * 100 : 0,
        color: situacaoColors[situacao] || situacaoColors["OUTROS"]
      }));
    },

gerarPlanilha() {
        // Objeto com os dados para a planilha
        const dados = this.itemsFiltered

        // Cria uma nova planilha
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(dados);

        // Adiciona a planilha ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Salva o workbook como arquivo
        XLSX.writeFile(workbook, 'RFI.xlsx');
      },

      loadEmpresas() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,   
               //  "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                              
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, nomeempresarial: emp.nomeempresarial }
            })
          })
      },  
      
      loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,   
               //  "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                              
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }        
            })
          })
      },

      loadSituacao() {
            let params = {    
                "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,       
                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                     
            };
          const url = `${baseApiUrl}/manutencao/rfi/situacao`
          axios.get(url,{params}).then(res => {
            this.situacoes = res.data.map(sit => {              
              return { id: sit.id, situacao: sit.situacao }        
            })
          })
      },

      loadStatus() {     
            let params = {    
                "empresa_id": `${this.valor_empresa.map(e => e.id_empresa)}`,       
                "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                     
            };       
          const url = `${baseApiUrl}/manutencao/rfi/status`
          axios.get(url,{params}).then(res => {
            this.statuss = res.data.map(sta => {              
              return { id: sta.id, status: sta.status}        
            })
          })
      },

      loadEmpresaCad() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,        
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                         
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo)
          .then(res => {this.empresasc = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },

      loadFiliaisCad() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,     
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                            
            };

          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
            .then(res => {
              this.filiaisc = res.data.map(fil => {                      
                return { ... fil, value: fil.id_filial_erp, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })              
            })
            .catch(showError)
      },

      loadSituacaoCad() {
            let params = {    
                "empresa_id": `${this.empresasc.map(e => e.id_empresa)}`,         
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                        
            };
          const url = `${baseApiUrl}/manutencao/rfi/situacao`
          axios.get(url,{params}).then(res => {
            this.situacoesc = res.data.map(sit => {                            
              return { ... sit, value: sit.id, situacao: sit.situacao }  //// para pegar o valor tem que usar o ... atribuicao value
            })
          })
      },

      loadStatusCad() {   
                    let params = {    
                "empresa_id": `${this.empresasc.map(e => e.id_empresa)}`,         
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                        
            };         
          const url = `${baseApiUrl}/manutencao/rfi/status`
          axios.get(url,{params}).then(res => {
            this.statussc = res.data.map(sta => {              
              return { ... sta, value: sta.id, status: sta.status}        
            })
          })
      },

      


        loadVeiculo() {
          let params = {    
              "id_empresa": `${this.user.id_empresa}`,
              "prefixo": `${this.rfi.carro}`       ,
               "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                   
          };
          const url = `${baseApiUrl}/frota/veiculo`
          axios.get(url,{params})                      
          .then(res => { this.veiculos = res.data })                      
          .catch(showError)
        },


loadRfi() {                        
    let params = {    
        empresa: this.user.id_empresa,  
        psg: this.user.psg // Adiciona 'psg' nos parâmetros
    };

    // Adiciona apenas os parâmetros que possuem valores
    if (this.valor_empresa.length) params.empresa_id = this.valor_empresa.map(e => e.id_empresa).join(',');
    if (this.valor_filial.length) params.filial_id = this.valor_filial.map(e => e.id_filial_erp).join(',');
    if (this.valor_situacao.length) params.situacao_id = this.valor_situacao.map(si => si.id).join(',');
    if (this.valor_status.length) params.status_id = this.valor_status.map(st => st.id).join(',');

    const url = `${baseApiUrl}/manutencao/rfi/lancamentos`;

    axios.get(url, { params })
        .then(res => { 
            this.rfilancamentos = res.data; 
        })
        .catch(showError);
},

       
        editCarregaRfi(rfi){
            this.rfi = { ...rfi}
        },



    postNroRfi() {
                          let params = {    
                "empresa_id": `${this.empresasc.map(e => e.id_empresa)}`,         
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                        
            };  
        const url = `${baseApiUrl}/manutencao/rfi/nro`
        axios.get(url,{params})
        .then(res => {            
           this.nroRfi = res.data.nroRfi;  // Acesse 'nroRfi' diretamente               
          })
        .catch(showError)
      //} 
    },
                
        
        async postRfi() {                  

          let corpo = {
            //"empresa_id": `${this.rfi.empresa_id}`,
            //"filial_id": `${this.rfi.filial_id}`,
            "empresa_id": this.veiculos.length > 0 ? this.veiculos[0]['id_empresa'] : `${this.rfi.empresa_id}`,
            "filial_id": this.veiculos.length > 0 ? this.veiculos[0]['id_filial'] : `${this.rfi.filial_id}`,
            "carro_id": this.veiculos.length > 0 ? this.veiculos[0]['id_veiculo'] : `${this.rfi.carro_id}`,
            "dt_parada": `${this.rfi.dt_parada}`,
            "dt_cadastro": `${this.rfi.dt_cadastro}`,
            "dt_prevista_liberacao": `${this.rfi.dt_prevista_liberacao}`,
            "motivo": `${this.rfi.motivo}`,
            "situacao_id": `${this.rfi.situacao_id}`,  
            "status_id": `${this.rfi.status_id}`,                  
            "pecas": `${this.rfi.pecas}`,
            "observacoes": `${this.rfi.observacoes}`,               
            "lavador": `${this.rfi.lavador}`,
            "id_funcionario": `${this.user.id_funcionario}`,     
            "id":  this.nroRfi ? this.nroRfi: this.rfi.id,
                             "psg": this.user.psg // Adiciona o 'psg' nos parâmetros      
          };

          const url = `${baseApiUrl}/manutencao/rfi`   

            axios.post(url,corpo).then(() => {
             // this.loadRfi()      
              this.postRfiPermancia()                   
              this.$toasted.global.defaultSuccess()   
              this.reset()  
              if(this.rfi.lavador){
            //    this.postLavador()  
              }

            })
            .catch(showError)
        },

        async postRfiPermancia() {                  

          let corpo = {
            //"empresa_id": `${this.rfi.empresa_id}`,
            //"filial_id": `${this.rfi.filial_id}`,
            "empresa_id": this.veiculos.length > 0 ? this.veiculos[0]['id_empresa'] : `${this.rfi.empresa_id}`,
            "filial_id": this.veiculos.length > 0 ? this.veiculos[0]['id_filial'] : `${this.rfi.filial_id}`,
            "carro_id": this.veiculos.length > 0 ? this.veiculos[0]['id_veiculo'] : `${this.rfi.carro_id}`,
            //"dt_parada": `${this.rfi.dt_parada}`,
            //"dt_cadastro": `${this.rfi.dt_cadastro}`,
            "situacao_id": `${this.rfi.situacao_id}`,                          
            "id_funcionario": `${this.user.id_funcionario}`,     
            "rfi_id":  this.nroRfi ? this.nroRfi: this.rfi.id,
            "psg": this.user.psg // Adiciona o 'psg' nos parâmetros      
          };

          const url = `${baseApiUrl}/manutencao/rfi/permanencia`   

            axios.post(url,corpo).then(() => {
             // this.loadRfi()            
              this.$toasted.global.defaultSuccess()                 

            })
            .catch(showError)
        },

        


        postLavador() {                        
          let corpo = {
            "empresa_id": `${this.rfi.empresa_id}`,
            "filial_id": `${this.rfi.filial_id}`,
            "origem_id":  this.nroRfi ? this.nroRfi: this.rfi.id,
            "origem": 1,  // 1 = rfi - 2 corretiva - 3 preventiva
            "lavador": `${this.rfi.lavador}`,
            "carro_id": this.veiculos.length > 0 ? this.veiculos[0]['id_veiculo'] : `${this.rfi.carro_id}`,            
            "id_funcionario": `${this.user.id_funcionario}`,     
                             "psg": this.user.psg // Adiciona o 'psg' nos parâmetros      
          };

          const url = `${baseApiUrl}/manutencao/lavador`   

            axios.post(url,corpo).then(() => {
              this.$toasted.global.defaultSuccess()              
              this.reset() //limpar os objetos valores
            })
            .catch(showError)
        },

        reset() {            
            this.rfi = {}
            this.rfi.id = ''
            this.rfi.carro = ''
            this.loadRfi()
            this.veiculos = ''            
        }
       
    },



    mounted() {        
      this.loadEmpresas()  
      this.loadSituacao()
      this.loadStatus()            
      this.loadRfi()
    },



}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.progress-container {
  display: flex;
  height: 20px;
  min-width: 120px; /* Garante um tamanho fixo mínimo */
  max-width: 120px;
  background-color: #e0e0e0;
  border-radius: 5px;
  overflow: hidden;
}

.progress-segment {
  height: 100%;
}

.flex-shrink-0 {
  flex-shrink: 0; /* Evita que o botão diminua */
}



/* CSS para definir largura da coluna 'Permanência' */
th.text-right {
  width: 200px;
}








</style>